import { css } from '@emotion/react';
import * as React from 'react';

import { Recipient } from 'api/api';

import { useGlobalState } from '~src/global-state';
import { CaretRightIcon } from '~src/icons/caret-right';
import { colors } from '~src/theme/colors';
import { fontStyles } from '~src/theme/fontStyles';
import { Heading } from '~src/ui/heading';
import { LinkButton } from '~src/ui/link-button';

import { applyPhoneNumberMask, formatRecipientToArray } from '~address-form/utils/format-ui';

interface SplitAddressCardUIProps {
  address: Recipient;
  onTopBoxClick: () => void;
  onBottomBoxClick: () => void;
  topHeading?: string;
  bottomHeading?: string;
}

export const SplitAddressCardUI: React.FC<SplitAddressCardUIProps> = ({
  address,
  onTopBoxClick,
  onBottomBoxClick,
  topHeading,
  bottomHeading,
}) => {
  const globalState = useGlobalState();

  const { email, phone_number, ...rest } = address;
  const topInfo = formatRecipientToArray(
    applyPhoneNumberMask({ email, phone_number }),
    globalState.purchase_country
  );
  const bottomInfo = formatRecipientToArray(rest, globalState.purchase_country);

  return (
    <>
      {topHeading && <Heading>{topHeading}</Heading>}
      <div css={styles.wrapper}>
        <div css={styles.body} data-test="user-top-info-box">
          {topInfo.map((line, idx) => (
            <div key={idx} css={styles.line} data-test="user-top-box-details">
              {line}
            </div>
          ))}
        </div>
        <LinkButton css={styles.button} onClick={onTopBoxClick} data-test="open-arrow">
          <CaretRightIcon />
        </LinkButton>
      </div>
      <div css={styles.divider} />
      {bottomHeading && <Heading>{bottomHeading}</Heading>}
      <div css={styles.wrapper}>
        <div css={styles.body} data-test="user-bottom-info-box">
          {bottomInfo.map((line, idx) => (
            <div key={idx} css={styles.line} data-test="user-bottom-box-details">
              {line}
            </div>
          ))}
        </div>
        <LinkButton css={styles.button} onClick={onBottomBoxClick} data-test="open-arrow">
          <CaretRightIcon />
        </LinkButton>
      </div>
    </>
  );
};

const styles = {
  wrapper: css({
    position: 'relative',
  }),
  divider: {
    marginTop: '32px',
  },
  line: {
    marginTop: '2px',
    color: colors.darkGrey,
  },
  body: {
    ...fontStyles.px14_20,
  },
  button: css({
    position: 'absolute',
    top: '50%',
    right: '16px',
    fontSize: 'inherit',
    fontVariationSettings: '"wght" 500',
    padding: '16px 8px 16px 16px',
    transform: 'translate(16px, -50%)',
  }),
};
